import React from "react";
import { Route } from "react-router-dom";
import { localizeRoutePath } from "../../Pages/Helpers/localizeRoutePath";

export const LocalizationRoute = (props) => {
  const { path, ...rest } = props;

  return <Route path={localizeRoutePath(path)} {...rest} />;
};
